var _path, _path2, _path3, _ellipse, _path4, _ellipse2, _path5, _ellipse3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _rect2, _rect3, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPendingReview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 116,
    viewBox: "0 0 1440 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M869.607 66.6914C856.942 65.2864 849.906 80.719 849.906 88.2126V100.858H911.471C909.361 100.507 912.175 97.4858 905.139 88.2126C898.103 78.9393 891.184 84.3487 888.604 88.2126C886.259 81.8899 882.272 68.0965 869.607 66.6914Z",
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M821.165 79.3891C808.428 78.4959 801.352 88.307 801.352 93.071V101.11H863.268C861.146 100.887 863.976 98.9663 856.9 93.071C849.824 87.1756 842.865 90.6146 840.271 93.071C837.912 89.0514 833.902 80.2824 821.165 79.3891Z",
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-16 101L1471 101",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 601.527,
    cy: 47.0191,
    rx: 23.2188,
    ry: 23.1831,
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M601.527 104.274V55.4492",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 628.266,
    cy: 56.855,
    rx: 23.2188,
    ry: 23.1831,
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M628.266 114.11V65.2852",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 787.281,
    cy: 53.3417,
    rx: 16.8864,
    ry: 29.5058,
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M787.281 107.626V72.1172",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M704.961 96.8984L704.961 101.114",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M735.918 91.9766V101.109",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M699.328 91.9766V101.109",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M510.062 91.9766V101.109",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M498.805 47.0165L536.717 2.75781L575.497 47.0165",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M506.543 49.1246L518.856 35.0742V94.0858",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M540.32 1H634.251L662.747 38.2335",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M655.004 52.9844V90.5691",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 523.434,
    y: 37.8789,
    width: 12.6648,
    height: 13.3479,
    fill: "#CADDFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 523.434,
    y: 54.7422,
    width: 24.626,
    height: 13.3479,
    fill: "#CADDFD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 523.434,
    y: 73.7109,
    width: 12.6648,
    height: 20.3731,
    fill: "#F3C477"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M569.52 51.9297V93.3783",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M515.691 19.2661V1.70312H523.079V11.8897",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingReview);
export default __webpack_public_path__ + "static/media/pending-review.6c5e1d49.svg";
export { ForwardRef as ReactComponent };